import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={18}
            height={18}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M16.57 11.887A7.813 7.813 0 116.25 1.684m10.343 4.174a7.81 7.81 0 01.57 2.365c.016.2.024.301-.016.392a.41.41 0 01-.172.186c-.087.047-.195.047-.412.047H10c-.218 0-.328 0-.411-.043a.39.39 0 01-.171-.17c-.043-.084-.043-.194-.043-.412V1.66c0-.217 0-.326.047-.412a.41.41 0 01.186-.172c.09-.04.191-.032.392-.016a7.812 7.812 0 016.593 4.798z"
                stroke={props.isHover ? theme["#0D968F"] : '#A0A0A0'}
                strokeWidth={1.5625}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
  
  export default SvgComponent